export default "__VITE_ASSET__YYBwpw5x5TUaWMuuqY8pNg__"